import { render, staticRenderFns } from "./PolizasFinanzasImportView.vue?vue&type=template&id=66abf633&"
import script from "./PolizasFinanzasImportView.vue?vue&type=script&lang=js&"
export * from "./PolizasFinanzasImportView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports